import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetBoxComponent } from '../../widgets/box/box.component';
import { WidgetOptionComponent } from '../../widgets/option/option.component';
import { SettingHelper } from '../../helpers/setting.helper';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  imports: [
    CommonModule,
    WidgetBoxComponent,
    WidgetOptionComponent,
  ]
})
export class AppSettingsComponent {

  /**
   * Setting helper
   */
  setting_helper = inject(SettingHelper);

  /**
   * Settings
   */
  settings = computed(() => this.setting_helper.store().settings);

  /**
   * Indexers
   */
  indexers = computed(() => this.setting_helper.listIndexers());

  /**
   * Graphql providers
   */
  graphql_providers = computed(() => this.setting_helper.listGraphqlProviders());

  /**
   * Jsonrpc providers
   */
  jsonrpc_providers = computed(() => this.setting_helper.listJsonrpcProviders());

  /**
   * Change indexer
   * 
   * @param indexer
   */
  changeIndexer(indexer: string) {
    this.setting_helper.setIndexer(indexer);
  }

  /**
   * Change graphql provider
   * 
   * @param provider
   */
  changeGraphqlProvider(provider: string) {
    this.setting_helper.setGraphqlProvider(provider);
  }

  /**
   * Change jsonrpc provider
   * 
   * @param provider
   */
  changeJsonrpcProvider(provider: string) {
    this.setting_helper.setJsonrpcProvider(provider);
  }
}
